import { useState } from "react";
import { Box, BoxProps } from "@chakra-ui/react";

import type { ColorType } from "@noli/core";
import { ColorPreviewProps } from "@noli/noli-ui/dist/components/ColorPreview";
import { ColorPickerPopup, ColorPickerPopupProps, ColorPreview } from "@noli/noli-ui";

import { svgColorToUiColor, uiColorToSvgColor } from "./utils";

export interface IColorPicker extends BoxProps {
  originalColor: ColorType;
  colorPickerPopupProps?: Partial<ColorPickerPopupProps>;
  colorPreviewProps?: Omit<ColorPreviewProps, "color">;
  onColorChange: (color: ColorType) => void;
  onColorChangeComplete: (color: ColorType) => void;
}

function ColorPicker({
  originalColor,
  colorPickerPopupProps,
  colorPreviewProps,
  onColorChange,
  onColorChangeComplete,
  ...others
}: IColorPicker) {
  const [colorVisible, setColorVisible] = useState(false);
  const uiColor = svgColorToUiColor(originalColor);

  return (
    <Box {...others}>
      <ColorPickerPopup
        key={originalColor.order}
        value={uiColor}
        onChange={(color) => onColorChange(uiColorToSvgColor(color, originalColor))}
        onChangeComplete={(color) => onColorChangeComplete(uiColorToSvgColor(color, originalColor))}
        visible={colorVisible}
        onVisibleChange={setColorVisible}
        {...(colorPickerPopupProps ?? {})}
      >
        <ColorPreview color={uiColor} {...(colorPreviewProps ?? {})} />
      </ColorPickerPopup>
    </Box>
  );
}

export default ColorPicker;
